import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import FabricCare from "./action/fabricCare";

/**
 * Thin Modal shell around FabricCare (the actual form: short description + the two
 * global-library multi-selects). Conditionally rendering FabricCare only while `open`
 * is true — rather than always mounting it and toggling visibility — means every open
 * is a fresh mount, so FabricCare's own [productId] fetch-on-mount effect always runs
 * against the current product with no stale state from a previous row, matching the
 * clear-on-open/close convention used by ManageWearItToModal / ManageSignatureDetailsModal.
 */
const ManageFabricCareModal = ({ open, onClose, productId, productCode, productColour }) => {
  return (
    <Modal isOpen={open} toggle={onClose} className="modal-dialog-centered" size="lg">
      <ModalHeader toggle={onClose} tag="div">
        <div>Fabric & Care</div>
        {(productCode || (Array.isArray(productColour) && productColour.filter(Boolean).length > 0)) && (
          <div style={{ fontSize: "0.8rem", fontWeight: 400, color: "#888", marginTop: 2 }}>
            {[productCode, Array.isArray(productColour) ? productColour.filter(Boolean).join(", ") : productColour]
              .filter(Boolean)
              .join(" · ")}
          </div>
        )}
      </ModalHeader>
      <ModalBody>
        {open && <FabricCare productId={productId} closeDialog={onClose} />}
      </ModalBody>
    </Modal>
  );
};

export default ManageFabricCareModal;
